import { useEffect, useState } from "react";
import { totalRotation } from "./geometry";

// เรนเดอร์ใบเดียวลง canvas เมื่อมองเห็น (lazy) และเรนเดอร์ใหม่เมื่อซูม/หมุน
export function useInView(ref, rootMargin = "800px") {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { rootMargin });
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, rootMargin]);
  return visible;
}

export function usePageRender(canvasRef, pdfDoc, page, scale, enabled) {
  const R = totalRotation(page);

  useEffect(() => {
    if (!enabled || !pdfDoc) return undefined;
    let cancelled = false;
    let task = null;

    (async () => {
      try {
        const pdfPage = await pdfDoc.getPage(page.srcIndex + 1);
        if (cancelled) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const base = pdfPage.getViewport({ scale: 1, rotation: R });
        const s = Math.min(scale * dpr, 4096 / Math.max(base.width, base.height));
        const viewport = pdfPage.getViewport({ scale: s, rotation: R });

        // วาดลง buffer ก่อนแล้วค่อยสลับ กันภาพกะพริบตอนซูม
        const buffer = document.createElement("canvas");
        buffer.width = Math.max(1, Math.floor(viewport.width));
        buffer.height = Math.max(1, Math.floor(viewport.height));
        task = pdfPage.render({ canvasContext: buffer.getContext("2d"), viewport });
        await task.promise;
        if (cancelled || !canvasRef.current) return;

        const canvas = canvasRef.current;
        canvas.width = buffer.width;
        canvas.height = buffer.height;
        canvas.getContext("2d").drawImage(buffer, 0, 0);
      } catch (error) {
        // RenderingCancelledException = ถูกยกเลิกเพราะซูม/หมุนซ้ำ ไม่ใช่ข้อผิดพลาด
      }
    })();

    return () => {
      cancelled = true;
      if (task) task.cancel();
    };
  }, [canvasRef, pdfDoc, page.srcIndex, R, scale, enabled]);
}
